module.exports = __webpack_public_path__ + "img/bg.47abb80f.png";